// ProductionBatchDetailPage.jsx
// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   Chip,
//   Divider,
//   Paper,
//   IconButton,
//   Stepper,
//   Step,
//   StepLabel,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   Alert,
//   CircularProgress,
//   AppBar,
//   Toolbar,
//   Breadcrumbs,
//   Link,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
// } from "@mui/material";
// import {
//   ArrowBack as BackIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   LocalShipping as BatchIcon,
//   Science as ScienceIcon,
//   CalendarToday as DateIcon,
//   WaterDrop as VolumeIcon,
//   Analytics as QualityIcon,
//   Storage as TankIcon,
//   List as SessionsIcon,
//   Home as HomeIcon,
//   Grain as MilkIcon,
// } from "@mui/icons-material";
// import { useParams, useNavigate, Link as RouterLink } from "react-router-dom";
// import swal from "sweetalert";

// const ProductionBatchDetailPage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [batch, setBatch] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [relatedSessions, setRelatedSessions] = useState([]);

//   const API_URL = "https://dairy.server.statify.co.ke/api/production-batches";

//   // Fetch batch details
//   const fetchBatchDetails = async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(`${API_URL}/${id}`);
//       const data = await res.json();
      
//       if (data) {
//         // Transform data
//         const transformedBatch = {
//           ...data,
//           status: data.quality_score >= 90 ? "Excellent" : 
//                  data.quality_score >= 75 ? "Good" :
//                  data.quality_score >= 60 ? "Fair" : "Poor",
//           created_at: new Date(data.created_at).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit'
//           })
//         };
//         setBatch(transformedBatch);
//         setRelatedSessions(data.milking_sessions || []);
//       }
//     } catch (err) {
//       console.error('Error fetching batch details:', err);
//       swal("Error", "Failed to fetch batch details", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (id) {
//       fetchBatchDetails();
//     }
//   }, [id]);

//   // Get Quality Color
//   const getQualityColor = (score) => {
//     if (score >= 90) return 'success';
//     if (score >= 75) return 'info';
//     if (score >= 60) return 'warning';
//     return 'error';
//   };

//   // Get Status Color
//   const getStatusColor = (status) => {
//     switch (status) {
//       case 'Excellent': return 'success';
//       case 'Good': return 'info';
//       case 'Fair': return 'warning';
//       case 'Poor': return 'error';
//       default: return 'default';
//     }
//   };

//   // Handle Delete
//   const handleDelete = async () => {
//     const confirm = await swal({
//       title: "Are you sure?",
//       text: "This will permanently delete the production batch!",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${id}`, { method: "DELETE" });
//         const data = await res.json();
//         if (res.ok) {
//           swal("Deleted!", data.message, "success");
//           navigate("/production-batches");
//         } else {
//           swal("Error", data.error, "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       }
//     }
//   };

//   // Handle Edit
//   const handleEdit = () => {
//     navigate(`/production-batches/edit/${id}`);
//   };

//   // Quality Progress Steps
//   const qualitySteps = [
//     { label: 'Poor', threshold: 59, color: 'error' },
//     { label: 'Fair', threshold: 74, color: 'warning' },
//     { label: 'Good', threshold: 89, color: 'info' },
//     { label: 'Excellent', threshold: 100, color: 'success' }
//   ];

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
//         <CircularProgress size={60} />
//       </Box>
//     );
//   }

//   if (!batch) {
//     return (
//       <Box sx={{ p: 3 }}>
//         <Alert severity="error" sx={{ mb: 2 }}>
//           Batch not found
//         </Alert>
//         <Button startIcon={<BackIcon />} onClick={() => navigate("/production-batches")}>
//           Back to Batches
//         </Button>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
//       {/* Header */}
//       <AppBar position="static" elevation={2} sx={{ backgroundColor: 'primary.dark' }}>
//         <Toolbar>
//           <IconButton
//             edge="start"
//             color="inherit"
//             onClick={() => navigate("/production-batches")}
//             sx={{ mr: 2 }}
//           >
//             <BackIcon />
//           </IconButton>
//           <BatchIcon sx={{ mr: 2 }} />
//           <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
//             Batch Details
//           </Typography>
//           <Box sx={{ display: 'flex', gap: 1 }}>
//             <Button
//               variant="outlined"
//               color="inherit"
//               startIcon={<EditIcon />}
//               onClick={handleEdit}
//             >
//               Edit
//             </Button>
//             <Button
//               variant="outlined"
//               color="error"
//               startIcon={<DeleteIcon />}
//               onClick={handleDelete}
//             >
//               Delete
//             </Button>
//           </Box>
//         </Toolbar>
//       </AppBar>

//       {/* Breadcrumbs */}
//       <Box sx={{ p: 2, pt: 3 }}>
//         <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
//           <Link component={RouterLink} to="/" color="inherit" sx={{ display: 'flex', alignItems: 'center' }}>
//             <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
//             Home
//           </Link>
//           <Link component={RouterLink} to="/production-batches" color="inherit" sx={{ display: 'flex', alignItems: 'center' }}>
//             <BatchIcon sx={{ mr: 0.5 }} fontSize="inherit" />
//             Production Batches
//           </Link>
//           <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
//             <ScienceIcon sx={{ mr: 0.5 }} fontSize="inherit" />
//             {batch.batch_code}
//           </Typography>
//         </Breadcrumbs>
//       </Box>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Grid container spacing={3}>
//           {/* Left Column - Batch Information */}
//           <Grid item xs={12} md={8}>
//             {/* Batch Overview Card */}
//             <Card sx={{ mb: 3, borderRadius: 3, boxShadow: 3 }}>
//               <CardContent sx={{ p: 4 }}>
//                 <Grid container spacing={4} alignItems="center">
//                   <Grid item xs={12} sm={3}>
//                     <Box
//                       sx={{
//                         width: 120,
//                         height: 120,
//                         borderRadius: '50%',
//                         backgroundColor: 'primary.main',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         mx: 'auto',
//                         boxShadow: 3
//                       }}
//                     >
//                       <BatchIcon sx={{ fontSize: 50, color: 'white' }} />
//                     </Box>
//                   </Grid>
//                   <Grid item xs={12} sm={9}>
//                     <Typography variant="h3" component="h2" gutterBottom color="primary.main" sx={{ fontWeight: 'bold' }}>
//                       {batch.batch_code}
//                     </Typography>
//                     <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
//                       <Chip
//                         label={batch.status}
//                         color={getStatusColor(batch.status)}
//                         variant="filled"
//                         size="large"
//                         sx={{ fontSize: '1rem', fontWeight: 'bold' }}
//                       />
//                       <Chip
//                         icon={<DateIcon />}
//                         label={`Created: ${batch.created_at}`}
//                         variant="outlined"
//                         size="large"
//                       />
//                     </Box>
//                     <Typography variant="body1" color="text.secondary">
//                       Production batch containing milk from multiple milking sessions with comprehensive quality tracking.
//                     </Typography>
//                   </Grid>
//                 </Grid>
//               </CardContent>
//             </Card>

//             {/* Quality Metrics Card */}
//             <Card sx={{ mb: 3, borderRadius: 3, boxShadow: 2 }}>
//               <CardContent sx={{ p: 4 }}>
//                 <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3, display: 'flex', alignItems: 'center' }}>
//                   <QualityIcon sx={{ mr: 1, color: 'primary.main' }} />
//                   Quality Metrics
//                 </Typography>
                
//                 {/* Quality Score Progress */}
//                 <Box sx={{ mb: 4 }}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
//                     <Typography variant="h6">Quality Score</Typography>
//                     <Typography variant="h4" color="primary.main" sx={{ fontWeight: 'bold' }}>
//                       {batch.quality_score || 'N/A'}%
//                     </Typography>
//                   </Box>
//                   <Stepper activeStep={qualitySteps.findIndex(step => (batch.quality_score || 0) <= step.threshold)} alternativeLabel>
//                     {qualitySteps.map((step) => (
//                       <Step key={step.label}>
//                         <StepLabel 
//                           StepIconProps={{ 
//                             sx: { 
//                               color: (batch.quality_score || 0) <= step.threshold ? step.color : 'grey.300'
//                             } 
//                           }}
//                         >
//                           {step.label}
//                         </StepLabel>
//                       </Step>
//                     ))}
//                   </Stepper>
//                 </Box>

//                 <Divider sx={{ my: 3 }} />

//                 {/* Key Metrics Grid */}
//                 <Grid container spacing={3}>
//                   <Grid item xs={12} sm={6} md={3}>
//                     <Paper sx={{ p: 3, textAlign: 'center', backgroundColor: 'primary.light', color: 'white' }}>
//                       <VolumeIcon sx={{ fontSize: 40, mb: 1 }} />
//                       <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
//                         {batch.total_volume} L
//                       </Typography>
//                       <Typography variant="body2">Total Volume</Typography>
//                     </Paper>
//                   </Grid>
//                   <Grid item xs={12} sm={6} md={3}>
//                     <Paper sx={{ p: 3, textAlign: 'center', backgroundColor: 'info.main', color: 'white' }}>
//                       <SessionsIcon sx={{ fontSize: 40, mb: 1 }} />
//                       <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
//                         {relatedSessions.length}
//                       </Typography>
//                       <Typography variant="body2">Milking Sessions</Typography>
//                     </Paper>
//                   </Grid>
//                   <Grid item xs={12} sm={6} md={3}>
//                     <Paper sx={{ p: 3, textAlign: 'center', backgroundColor: 'success.main', color: 'white' }}>
//                       <TankIcon sx={{ fontSize: 40, mb: 1 }} />
//                       <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
//                         {batch.tank || 'N/A'}
//                       </Typography>
//                       <Typography variant="body2">Storage Tank</Typography>
//                     </Paper>
//                   </Grid>
//                   <Grid item xs={12} sm={6} md={3}>
//                     <Paper sx={{ p: 3, textAlign: 'center', backgroundColor: 'warning.main', color: 'white' }}>
//                       <MilkIcon sx={{ fontSize: 40, mb: 1 }} />
//                       <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
//                         {(batch.total_volume / (relatedSessions.length || 1)).toFixed(1)} L
//                       </Typography>
//                       <Typography variant="body2">Avg per Session</Typography>
//                     </Paper>
//                   </Grid>
//                 </Grid>
//               </CardContent>
//             </Card>

//             {/* Associated Sessions Card */}
//             <Card sx={{ borderRadius: 3, boxShadow: 2 }}>
//               <CardContent sx={{ p: 4 }}>
//                 <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3, display: 'flex', alignItems: 'center' }}>
//                   <SessionsIcon sx={{ mr: 1, color: 'primary.main' }} />
//                   Associated Milking Sessions ({relatedSessions.length})
//                 </Typography>

//                 {relatedSessions.length > 0 ? (
//                   <TableContainer component={Paper} variant="outlined">
//                     <Table>
//                       <TableHead>
//                         <TableRow sx={{ backgroundColor: 'primary.main' }}>
//                           <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Session Code</TableCell>
//                           <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Date</TableCell>
//                           <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Volume (L)</TableCell>
//                           <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Cows</TableCell>
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {relatedSessions.map((session) => (
//                           <TableRow key={session.id} hover>
//                             <TableCell>
//                               <Typography variant="body2" fontWeight="bold">
//                                 {session.session_code || `Session ${session.id}`}
//                               </Typography>
//                             </TableCell>
//                             <TableCell>
//                               {new Date(session.session_date || session.created_at).toLocaleDateString()}
//                             </TableCell>
//                             <TableCell>
//                               <Chip 
//                                 label={`${session.total_volume || 'N/A'} L`} 
//                                 size="small" 
//                                 color="primary" 
//                                 variant="outlined"
//                               />
//                             </TableCell>
//                             <TableCell>
//                               <Chip 
//                                 label={session.cow_count || 'N/A'} 
//                                 size="small" 
//                                 color="secondary" 
//                               />
//                             </TableCell>
//                           </TableRow>
//                         ))}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
//                 ) : (
//                   <Alert severity="info" sx={{ borderRadius: 2 }}>
//                     No milking sessions are currently associated with this batch.
//                   </Alert>
//                 )}
//               </CardContent>
//             </Card>
//           </Grid>

//           {/* Right Column - Quick Actions & Details */}
//           <Grid item xs={12} md={4}>
//             {/* Quick Actions Card */}
//             <Card sx={{ mb: 3, borderRadius: 3, boxShadow: 2, border: 2, borderColor: 'primary.light' }}>
//               <CardContent sx={{ p: 3 }}>
//                 <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
//                   Quick Actions
//                 </Typography>
//                 <List>
//                   <ListItem button onClick={handleEdit} sx={{ borderRadius: 2, mb: 1 }}>
//                     <ListItemIcon>
//                       <EditIcon color="primary" />
//                     </ListItemIcon>
//                     <ListItemText primary="Edit Batch Details" secondary="Update batch information" />
//                   </ListItem>
//                   <ListItem button onClick={() => navigate(`/production-batches/${id}/sessions`)} sx={{ borderRadius: 2, mb: 1 }}>
//                     <ListItemIcon>
//                       <SessionsIcon color="info" />
//                     </ListItemIcon>
//                     <ListItemText primary="Manage Sessions" secondary="Add/remove milking sessions" />
//                   </ListItem>
//                   <ListItem button onClick={() => navigate("/production-batches")} sx={{ borderRadius: 2, mb: 1 }}>
//                     <ListItemIcon>
//                       <BatchIcon color="secondary" />
//                     </ListItemIcon>
//                     <ListItemText primary="View All Batches" secondary="Return to batches list" />
//                   </ListItem>
//                 </List>
//               </CardContent>
//             </Card>

//             {/* Batch Information Card */}
//             <Card sx={{ borderRadius: 3, boxShadow: 2 }}>
//               <CardContent sx={{ p: 3 }}>
//                 <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
//                   Batch Information
//                 </Typography>
//                 <List>
//                   <ListItem sx={{ px: 0 }}>
//                     <ListItemIcon>
//                       <BatchIcon color="primary" />
//                     </ListItemIcon>
//                     <ListItemText 
//                       primary="Batch Code" 
//                       secondary={batch.batch_code}
//                       secondaryTypographyProps={{ variant: 'body1', fontWeight: 'bold' }}
//                     />
//                   </ListItem>
//                   <ListItem sx={{ px: 0 }}>
//                     <ListItemIcon>
//                       <TankIcon color="primary" />
//                     </ListItemIcon>
//                     <ListItemText 
//                       primary="Storage Tank" 
//                       secondary={batch.tank || 'Not specified'}
//                       secondaryTypographyProps={{ variant: 'body1' }}
//                     />
//                   </ListItem>
//                   <ListItem sx={{ px: 0 }}>
//                     <ListItemIcon>
//                       <VolumeIcon color="primary" />
//                     </ListItemIcon>
//                     <ListItemText 
//                       primary="Total Volume" 
//                       secondary={`${batch.total_volume} Liters`}
//                       secondaryTypographyProps={{ variant: 'body1', fontWeight: 'bold' }}
//                     />
//                   </ListItem>
//                   <ListItem sx={{ px: 0 }}>
//                     <ListItemIcon>
//                       <QualityIcon color="primary" />
//                     </ListItemIcon>
//                     <ListItemText 
//                       primary="Quality Score" 
//                       secondary={
//                         <Chip 
//                           label={batch.quality_score ? `${batch.quality_score}%` : 'Not rated'} 
//                           color={getQualityColor(batch.quality_score || 0)}
//                           size="small"
//                         />
//                       }
//                     />
//                   </ListItem>
//                   <ListItem sx={{ px: 0 }}>
//                     <ListItemIcon>
//                       <DateIcon color="primary" />
//                     </ListItemIcon>
//                     <ListItemText 
//                       primary="Created Date" 
//                       secondary={batch.created_at}
//                       secondaryTypographyProps={{ variant: 'body2' }}
//                     />
//                   </ListItem>
//                 </List>
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>
//       </Box>
//     </Box>
//   );
// };

// export default ProductionBatchDetailPage;

import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  Chip,
  Divider,
  Paper,
  IconButton,
  Stepper,
  Step,
  StepLabel,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Alert,
  CircularProgress,
  AppBar,
  Toolbar,
  Breadcrumbs,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  ArrowBack as BackIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  LocalShipping as BatchIcon,
  Science as ScienceIcon,
  CalendarToday as DateIcon,
  WaterDrop as VolumeIcon,
  Analytics as QualityIcon,
  Storage as TankIcon,
  List as SessionsIcon,
  Home as HomeIcon,
  Grain as MilkIcon,
} from "@mui/icons-material";
import { useParams, useNavigate, Link as RouterLink } from "react-router-dom";
import swal from "sweetalert";

const ProductionBatchDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [batch, setBatch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [relatedSessions, setRelatedSessions] = useState([]);

  const API_URL = "https://dairy.server.statify.co.ke/api/production-batches";

  // Custom color theme
  const customColors = {
    primary: '#024A59', // Dark teal
    secondary: '#FFA916', // Orange
    lightTeal: '#e6f0f2',
    lightOrange: '#fff5e6'
  };

  // Fetch batch details
  const fetchBatchDetails = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/${id}`);
      const data = await res.json();
      
      if (data) {
        // Transform data
        const transformedBatch = {
          ...data,
          status: data.quality_score >= 90 ? "Excellent" : 
                 data.quality_score >= 75 ? "Good" :
                 data.quality_score >= 60 ? "Fair" : "Poor",
          created_at: new Date(data.created_at).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })
        };
        setBatch(transformedBatch);
        setRelatedSessions(data.milking_sessions || []);
      }
    } catch (err) {
      console.error('Error fetching batch details:', err);
      swal("Error", "Failed to fetch batch details", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchBatchDetails();
    }
  }, [id]);

  // Get Quality Color
  const getQualityColor = (score) => {
    if (score >= 90) return 'success';
    if (score >= 75) return 'info';
    if (score >= 60) return 'warning';
    return 'error';
  };

  // Get Status Color
  const getStatusColor = (status) => {
    switch (status) {
      case 'Excellent': return 'success';
      case 'Good': return 'info';
      case 'Fair': return 'warning';
      case 'Poor': return 'error';
      default: return 'default';
    }
  };

  // Handle Delete
  const handleDelete = async () => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "This will permanently delete the production batch!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirm) {
      try {
        const res = await fetch(`${API_URL}/${id}`, { method: "DELETE" });
        const data = await res.json();
        if (res.ok) {
          swal("Deleted!", data.message, "success");
          navigate("/production-batches");
        } else {
          swal("Error", data.error, "error");
        }
      } catch (err) {
        swal("Error", "Something went wrong", "error");
      }
    }
  };

  // Handle Edit
  const handleEdit = () => {
    navigate(`/production-batches/edit/${id}`);
  };

  // Quality Progress Steps
  const qualitySteps = [
    { label: 'Poor', threshold: 59, color: 'error' },
    { label: 'Fair', threshold: 74, color: 'warning' },
    { label: 'Good', threshold: 89, color: 'info' },
    { label: 'Excellent', threshold: 100, color: 'success' }
  ];

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress size={60} sx={{ color: customColors.primary }} />
      </Box>
    );
  }

  if (!batch) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          Batch not found
        </Alert>
        <Button 
          startIcon={<BackIcon />} 
          onClick={() => navigate("/production-batches")}
          sx={{ 
            backgroundColor: customColors.primary,
            color: 'white',
            '&:hover': {
              backgroundColor: '#023a47',
            }
          }}
        >
          Back to Batches
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
      {/* Header */}
      <AppBar position="static" elevation={2} sx={{ backgroundColor: customColors.primary }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => navigate("/production-batches")}
            sx={{ mr: 2 }}
          >
            <BackIcon />
          </IconButton>
          <BatchIcon sx={{ mr: 2 }} />
          <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            Batch Details
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="outlined"
              color="inherit"
              startIcon={<EditIcon />}
              onClick={handleEdit}
              sx={{
                borderColor: 'white',
                color: 'white',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderColor: 'white'
                }
              }}
            >
              Edit
            </Button>
            <Button
              variant="outlined"
              color="inherit"
              startIcon={<DeleteIcon />}
              onClick={handleDelete}
              sx={{
                borderColor: 'white',
                color: 'white',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderColor: 'white'
                }
              }}
            >
              Delete
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Breadcrumbs */}
      <Box sx={{ p: 2, pt: 3 }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
          <Link 
            component={RouterLink} 
            to="/" 
            color="inherit" 
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              color: customColors.primary,
              '&:hover': {
                color: customColors.secondary,
              }
            }}
          >
            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            Home
          </Link>
          <Link 
            component={RouterLink} 
            to="/production-batches" 
            color="inherit" 
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              color: customColors.primary,
              '&:hover': {
                color: customColors.secondary,
              }
            }}
          >
            <BatchIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            Production Batches
          </Link>
          <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
            <ScienceIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            {batch.batch_code}
          </Typography>
        </Breadcrumbs>
      </Box>

      {/* Main Content */}
      <Box sx={{ p: 3 }}>
        <Grid container spacing={3}>
          {/* Left Column - Batch Information */}
          <Grid item xs={12} md={8}>
            {/* Batch Overview Card */}
            <Card sx={{ 
              mb: 3, 
              borderRadius: 3, 
              boxShadow: 3,
              border: `2px solid ${customColors.lightTeal}`
            }}>
              <CardContent sx={{ p: 4 }}>
                <Grid container spacing={4} alignItems="center">
                  <Grid item xs={12} sm={3}>
                    <Box
                      sx={{
                        width: 120,
                        height: 120,
                        borderRadius: '50%',
                        backgroundColor: customColors.primary,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mx: 'auto',
                        boxShadow: 3
                      }}
                    >
                      <BatchIcon sx={{ fontSize: 50, color: 'white' }} />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <Typography 
                      variant="h3" 
                      component="h2" 
                      gutterBottom 
                      sx={{ 
                        fontWeight: 'bold',
                        color: customColors.primary
                      }}
                    >
                      {batch.batch_code}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
                      <Chip
                        label={batch.status}
                        color={getStatusColor(batch.status)}
                        variant="filled"
                        size="large"
                        sx={{ fontSize: '1rem', fontWeight: 'bold' }}
                      />
                      <Chip
                        icon={<DateIcon />}
                        label={`Created: ${batch.created_at}`}
                        variant="outlined"
                        size="large"
                        sx={{
                          borderColor: customColors.primary,
                          color: customColors.primary
                        }}
                      />
                    </Box>
                    <Typography variant="body1" color="text.secondary">
                      Production batch containing milk from multiple milking sessions with comprehensive quality tracking.
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            {/* Quality Metrics Card */}
            <Card sx={{ 
              mb: 3, 
              borderRadius: 3, 
              boxShadow: 2,
              border: `1px solid ${customColors.lightTeal}`
            }}>
              <CardContent sx={{ p: 4 }}>
                <Typography 
                  variant="h5" 
                  gutterBottom 
                  sx={{ 
                    fontWeight: 'bold', 
                    mb: 3, 
                    display: 'flex', 
                    alignItems: 'center',
                    color: customColors.primary
                  }}
                >
                  <QualityIcon sx={{ mr: 1, color: customColors.primary }} />
                  Quality Metrics
                </Typography>
                
                {/* Quality Score Progress */}
                <Box sx={{ mb: 4 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="h6">Quality Score</Typography>
                    <Typography 
                      variant="h4" 
                      sx={{ 
                        fontWeight: 'bold',
                        color: customColors.secondary
                      }}
                    >
                      {batch.quality_score || 'N/A'}%
                    </Typography>
                  </Box>
                  <Stepper activeStep={qualitySteps.findIndex(step => (batch.quality_score || 0) <= step.threshold)} alternativeLabel>
                    {qualitySteps.map((step) => (
                      <Step key={step.label}>
                        <StepLabel 
                          StepIconProps={{ 
                            sx: { 
                              color: (batch.quality_score || 0) <= step.threshold ? step.color : 'grey.300'
                            } 
                          }}
                        >
                          {step.label}
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </Box>

                <Divider sx={{ my: 3 }} />

                {/* Key Metrics Grid */}
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={3}>
                    <Paper sx={{ 
                      p: 3, 
                      textAlign: 'center', 
                      backgroundColor: customColors.primary, 
                      color: 'white',
                      transition: 'transform 0.2s',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: 4
                      }
                    }}>
                      <VolumeIcon sx={{ fontSize: 40, mb: 1 }} />
                      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
                        {batch.total_volume} L
                      </Typography>
                      <Typography variant="body2">Total Volume</Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Paper sx={{ 
                      p: 3, 
                      textAlign: 'center', 
                      backgroundColor: customColors.secondary, 
                      color: 'white',
                      transition: 'transform 0.2s',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: 4
                      }
                    }}>
                      <SessionsIcon sx={{ fontSize: 40, mb: 1 }} />
                      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
                        {relatedSessions.length}
                      </Typography>
                      <Typography variant="body2">Milking Sessions</Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Paper sx={{ 
                      p: 3, 
                      textAlign: 'center', 
                      backgroundColor: customColors.primary, 
                      color: 'white',
                      opacity: 0.9,
                      transition: 'transform 0.2s',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: 4
                      }
                    }}>
                      <TankIcon sx={{ fontSize: 40, mb: 1 }} />
                      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
                        {batch.tank || 'N/A'}
                      </Typography>
                      <Typography variant="body2">Storage Tank</Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Paper sx={{ 
                      p: 3, 
                      textAlign: 'center', 
                      backgroundColor: customColors.secondary, 
                      color: 'white',
                      opacity: 0.9,
                      transition: 'transform 0.2s',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: 4
                      }
                    }}>
                      <MilkIcon sx={{ fontSize: 40, mb: 1 }} />
                      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
                        {(batch.total_volume / (relatedSessions.length || 1)).toFixed(1)} L
                      </Typography>
                      <Typography variant="body2">Avg per Session</Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            {/* Associated Sessions Card */}
            <Card sx={{ 
              borderRadius: 3, 
              boxShadow: 2,
              border: `1px solid ${customColors.lightTeal}`
            }}>
              <CardContent sx={{ p: 4 }}>
                <Typography 
                  variant="h5" 
                  gutterBottom 
                  sx={{ 
                    fontWeight: 'bold', 
                    mb: 3, 
                    display: 'flex', 
                    alignItems: 'center',
                    color: customColors.primary
                  }}
                >
                  <SessionsIcon sx={{ mr: 1, color: customColors.primary }} />
                  Associated Milking Sessions ({relatedSessions.length})
                </Typography>

                {relatedSessions.length > 0 ? (
                  <TableContainer component={Paper} variant="outlined">
                    <Table>
                      <TableHead>
                        <TableRow sx={{ backgroundColor: customColors.primary }}>
                          <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Session Code</TableCell>
                          <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Date</TableCell>
                          <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Volume (L)</TableCell>
                          <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Cows</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {relatedSessions.map((session) => (
                          <TableRow 
                            key={session.id} 
                            hover
                            sx={{
                              '&:hover': {
                                backgroundColor: customColors.lightOrange
                              }
                            }}
                          >
                            <TableCell>
                              <Typography variant="body2" fontWeight="bold">
                                {session.session_code || `Session ${session.id}`}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              {new Date(session.session_date || session.created_at).toLocaleDateString()}
                            </TableCell>
                            <TableCell>
                              <Chip 
                                label={`${session.total_volume || 'N/A'} L`} 
                                size="small" 
                                sx={{
                                  backgroundColor: customColors.primary,
                                  color: 'white'
                                }}
                              />
                            </TableCell>
                            <TableCell>
                              <Chip 
                                label={session.cow_count || 'N/A'} 
                                size="small" 
                                sx={{
                                  backgroundColor: customColors.secondary,
                                  color: 'white'
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Alert severity="info" sx={{ borderRadius: 2 }}>
                    No milking sessions are currently associated with this batch.
                  </Alert>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Right Column - Quick Actions & Details */}
          <Grid item xs={12} md={4}>
            {/* Quick Actions Card */}
            <Card sx={{ 
              mb: 3, 
              borderRadius: 3, 
              boxShadow: 2, 
              border: 2, 
              borderColor: customColors.primary,
              backgroundColor: customColors.lightTeal
            }}>
              <CardContent sx={{ p: 3 }}>
                <Typography 
                  variant="h6" 
                  gutterBottom 
                  sx={{ 
                    fontWeight: 'bold', 
                    color: customColors.primary 
                  }}
                >
                  Quick Actions
                </Typography>
                <List>
                  <ListItem 
                    button 
                    onClick={handleEdit} 
                    sx={{ 
                      borderRadius: 2, 
                      mb: 1,
                      '&:hover': {
                        backgroundColor: customColors.lightOrange
                      }
                    }}
                  >
                    <ListItemIcon>
                      <EditIcon sx={{ color: customColors.primary }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Edit Batch Details" 
                      secondary="Update batch information" 
                      primaryTypographyProps={{ color: customColors.primary, fontWeight: 'medium' }}
                    />
                  </ListItem>
                  <ListItem 
                    button 
                    onClick={() => navigate(`/production-batches/${id}/sessions`)} 
                    sx={{ 
                      borderRadius: 2, 
                      mb: 1,
                      '&:hover': {
                        backgroundColor: customColors.lightOrange
                      }
                    }}
                  >
                    <ListItemIcon>
                      <SessionsIcon sx={{ color: customColors.primary }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Manage Sessions" 
                      secondary="Add/remove milking sessions" 
                      primaryTypographyProps={{ color: customColors.primary, fontWeight: 'medium' }}
                    />
                  </ListItem>
                  <ListItem 
                    button 
                    onClick={() => navigate("/production-batches")} 
                    sx={{ 
                      borderRadius: 2, 
                      mb: 1,
                      '&:hover': {
                        backgroundColor: customColors.lightOrange
                      }
                    }}
                  >
                    <ListItemIcon>
                      <BatchIcon sx={{ color: customColors.primary }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary="View All Batches" 
                      secondary="Return to batches list" 
                      primaryTypographyProps={{ color: customColors.primary, fontWeight: 'medium' }}
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>

            {/* Batch Information Card */}
            <Card sx={{ 
              borderRadius: 3, 
              boxShadow: 2,
              border: `1px solid ${customColors.lightTeal}`
            }}>
              <CardContent sx={{ p: 3 }}>
                <Typography 
                  variant="h6" 
                  gutterBottom 
                  sx={{ 
                    fontWeight: 'bold', 
                    color: customColors.primary 
                  }}
                >
                  Batch Information
                </Typography>
                <List>
                  <ListItem sx={{ px: 0 }}>
                    <ListItemIcon>
                      <BatchIcon sx={{ color: customColors.primary }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Batch Code" 
                      secondary={batch.batch_code}
                      secondaryTypographyProps={{ 
                        variant: 'body1', 
                        fontWeight: 'bold',
                        color: customColors.primary
                      }}
                    />
                  </ListItem>
                  <ListItem sx={{ px: 0 }}>
                    <ListItemIcon>
                      <TankIcon sx={{ color: customColors.primary }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Storage Tank" 
                      secondary={batch.tank || 'Not specified'}
                      secondaryTypographyProps={{ variant: 'body1' }}
                    />
                  </ListItem>
                  <ListItem sx={{ px: 0 }}>
                    <ListItemIcon>
                      <VolumeIcon sx={{ color: customColors.primary }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Total Volume" 
                      secondary={`${batch.total_volume} Liters`}
                      secondaryTypographyProps={{ 
                        variant: 'body1', 
                        fontWeight: 'bold',
                        color: customColors.primary
                      }}
                    />
                  </ListItem>
                  <ListItem sx={{ px: 0 }}>
                    <ListItemIcon>
                      <QualityIcon sx={{ color: customColors.primary }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Quality Score" 
                      secondary={
                        <Chip 
                          label={batch.quality_score ? `${batch.quality_score}%` : 'Not rated'} 
                          color={getQualityColor(batch.quality_score || 0)}
                          size="small"
                        />
                      }
                    />
                  </ListItem>
                  <ListItem sx={{ px: 0 }}>
                    <ListItemIcon>
                      <DateIcon sx={{ color: customColors.primary }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Created Date" 
                      secondary={batch.created_at}
                      secondaryTypographyProps={{ variant: 'body2' }}
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ProductionBatchDetailPage;